import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import {  Autoplay , Navigation, Pagination  ,EffectFade} from 'swiper/modules';

function statsblock() {
    const statsgrid = document.querySelector('[data-block="stats-grid"]');
    if (!statsgrid) { return; }
    
    const stats_box_1 = document.querySelector('[data-target="stats_box_1"]');
    const stats_box_2 = document.querySelector('[data-target="stats_box_2"]');
    const stats_box_3 = document.querySelector('[data-target="stats_box_3"]');
    const stats_box_4 = document.querySelector('[data-target="stats_box_4"]');

    const content_box_1 = stats_box_1?.children;
    const content_box_2 = stats_box_2?.children;
    const content_box_3 = stats_box_3?.children;
    const content_box_4 = stats_box_4?.children;

    const neck_box_1 = stats_box_1.querySelector('[data-target="neck"]');
    const neck_box_2 = stats_box_2.querySelector('[data-target="neck"]');
    const neck_box_3 = stats_box_3.querySelector('[data-target="neck"]');
    const neck_box_4 = stats_box_4.querySelector('[data-target="neck"]');


    const tlstatbox = gsap.timeline({
        scrollTrigger: {
            trigger: statsgrid,
            start: "top 80%",
        }
    });

    tlstatbox
    .from(stats_box_1, {autoAlpha:0, duration:.5, ease: "none"})
    .from(content_box_1, {autoAlpha:0, duration:.5, ease: "none"})
    .from(neck_box_1, {scaleX:0, scaleY:.8,  duration:1,  ease: "power3.out" }, "-=.4")

    .from(stats_box_2, { scale: 0, duration: .7, ease: "power3.out" } , "-=.8") 
    .from(content_box_2, {autoAlpha:0, duration:.3, ease: "none"}, "-=0.3")
    .from(neck_box_2, {scaleX:0, scaleY:.8,  duration:1,  ease: "power3.out" }, "-=.4")

    .from(stats_box_3, { scale: 0, duration: .7, ease: "power3.out" } , "-=.8") 
    .from(content_box_3, {autoAlpha:0, duration:.3, ease: "none"}, "-=0.3")
    .from(neck_box_3, {scaleX:0, scaleY:.8,  duration:1,  ease: "power3.out" }, "-=.4")

    .from(stats_box_4, { scale: 0, duration: .7, ease: "power3.out" } , "-=.8") 
    .from(content_box_4, {autoAlpha:0, duration:.3, ease: "none"}, "-=0.3")
    .from(neck_box_4, {scaleX:0, scaleY:.8,  duration:1,  ease: "power3.out" }, "-=.4")



      
}


export { statsblock }; 